import { Box, Typography } from "@mui/material";
import { TravelCity } from "../../types/Travel/TravelCity";
import { TransportOption } from "../../types/Travel/TravelTransportOption";

import { TravelTransportButton } from "./TravelTransportButton";

import useStyles from "./index.styles";

interface CityListItemProps {
  city: TravelCity;
  region: string;
  isCurrentCity: boolean;
  transportOptions: TransportOption[];
  onTransportSelect: (type: string, cityId: number) => void;
}

export const TravelCityListItem = ({
  city,
  region,
  isCurrentCity,
  transportOptions,
  onTransportSelect,
}: CityListItemProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.travelListItem}>
      <Typography sx={{ color: isCurrentCity ? "green!important" : "inherit" }}>
        {city.name}
      </Typography>
      <Typography sx={{ color: isCurrentCity ? "green!important" : "inherit" }}>
        {region}
      </Typography>

      <Box className={classes.travelListItemActions}>
        {!isCurrentCity &&
          transportOptions.map((option) => (
            <TravelTransportButton
              key={option.travelType}
              type={option.travelType}
              cost={option.cost}
              onClick={() => onTransportSelect(option.travelType, city.cityId)}
              disabled={option.disabled}
            />
          ))}
      </Box>

      {isCurrentCity && (
        <Box
          className={classes.placeholder}
          component="img"
          src="/assets/imgs/travel/placeholder.png"
          alt="current location"
        />
      )}
    </Box>
  );
};
